export default __webpack_public_path__ + "static/media/property_904.9bf5bbad.png";